import React from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";

const SelectTag = ({ name, control, options, label, onChange, defaultValue, isRequired = false }) => {
  return (
    <Controller
      name={name}
      rules={isRequired ? { required: `The ${label} field is required.` } : {}}
      control={control}
      defaultValue={defaultValue || null} // Set defaultValue from props
      render={({ field }) => (
        <Select
          {...field}
          cacheOptions
          defaultOptions
          options={options}
          isClearable
          value={options.find(option => option.value === field.value) || null} // Ensure correct pre-selection
          onChange={(selectedOption) => {
            field.onChange(selectedOption ? selectedOption.value : null);
            if (onChange) {
              onChange(selectedOption); // Call external onChange if provided
            }
          }}
          placeholder={`Select ${label}`}
        />
      )}
    />
  );
};

export default SelectTag;
